export function requestUserLocation(t) {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      reject(new Error(t('location.unsupported')));
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        resolve({
          latitude: position.coords.latitude,
          longitude: position.coords.longitude
        });
      },
      (error) => {
        reject(new Error(
          error.code === error.PERMISSION_DENIED
            ? t('location.denied')
            : t('location.unavailable')
        ));
      },
      { enableHighAccuracy: false, timeout: 15000, maximumAge: 300000 }
    );
  });
}
